import { LinkNode } from '@lexical/link';
import { LexicalEditor, ParagraphNode, TextNode, createEditor } from 'lexical';
import { NoWrapNode } from '../nodes/NoWrapNode';
import { $setEditorStateFromHtmlString } from '../Plugins/HtmlContentPlugin';
import { mainTheme } from '../Theme/mainTheme';

export const lexicalReferencesEditorConfig = {
  namespace: 'references-editor',
  editable: false,
  theme: mainTheme,
  onError: (error): void => {
    throw error;
  },
  nodes: [
    TextNode,
    ParagraphNode,
    LinkNode,
    NoWrapNode,
  ],
};

export function createLexicalReferencesEditor(html: string): LexicalEditor {
  const editor = createEditor(lexicalReferencesEditorConfig);
  editor.update(() => $setEditorStateFromHtmlString(html), { discrete: true });

  return editor;
}
